export const FIB = 'FIB';
export const MCQ = 'MCQ';
export const MULTISELECT = 'MultiSelect';
export const ARRANGEINORDER = 'Matching';       // Arrange items in correct order
export const MATCHINGPAIRS = 'MatchingPairs';   // Match terms with definitions
export const TRUE_FALSE = 'True/False';
export const SWIPELEFTRIGHT = 'SwipeLeftRight';
export const DRAGDROP = 'DragDrop';
